import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import Loading from '../../../../../../molecules/Loading'
import Alert from '../../../../../../atoms/Alert'
import ChatMessages from './ChatMessages'
import MessageInput from './MessageInput'

const useStyles = makeStyles(() => ({
  chatPanel: {
    background: 'linear-gradient(var(--color-ai-050), var(--color-ai-100))',
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '2px solid var(--color-ai-400)',
    borderRadius: 'var(--border-radius-xl)',
    boxShadow: 'var(--shadow-lg)'
  },
  chatInput: {
    width: '100%'
  },
  textInput: {
    backgroundColor: 'var(--color-neutral-400)',
    border: 'none',
    borderRadius: 'var(--border-radius-md)',
    outline: 'none',
    width: '100%',
    fontFamily: 'var(--font-sans)',
    padding: 'var(--padding-sm)'
  },
  chatMessage: {
    whiteSpace: 'pre'
  }
}))

function ChatPanel ({ messages, onNewMessage, onJsxAttachmentClick, isLoading, isErrored }) {
  const classes = useStyles()
  const inputRef = useRef(null)

  if (isLoading) {
    return (
      <div className={classes.chatPanel}>
        <Loading />
      </div>
    )
  }

  return (
    <div className={classes.chatPanel}>
      <ChatMessages messages={messages} onJsxAttachmentClick={onJsxAttachmentClick} />
      <div className={classes.chatInput}>
        {isErrored && (
          <div className='px-4 py-2'>
            <Alert variant='filled' severity='error'>
              <span className='font-size-xs'>There was an error processing your request.</span>
            </Alert>
          </div>
        )}
        <div className='relative w-full p-xs'>
          <MessageInput ref={inputRef} placeholder='Describe your idea' onSend={onNewMessage} />
        </div>
      </div>
    </div>
  )
}

ChatPanel.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({
    threadId: PropTypes.string,
    threadMessageId: PropTypes.string,
    actor: PropTypes.oneOf(['agent', 'user']),
    message: PropTypes.string,
    data: PropTypes.object,
    isGenerating: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    generationStatus: PropTypes.string,
    responseId: PropTypes.string
  })).isRequired,
  onNewMessage: PropTypes.func.isRequired,
  onJsxAttachmentClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isErrored: PropTypes.bool
}

export default ChatPanel
